export default __webpack_public_path__ + "static/media/avaliacaoBG.3aed948d.jpg";